//营销管理
import http from '../jslibs/axios/http';

// 工作台
export const getDesk = data => http.get('/cms/Desk', data);

